<template>
  <div id="list">
    <span id="loading" v-if="this.load == true"><loading />
    </span>
    <h1>Todos os Candidatos</h1>
    <input v-model="search" placeholder="Pesquisar..." />
    <select class="form-select" v-model="idJob">
      <option selected value="all">Empregos - Todos</option>
      <option v-for="job in jobs" :key="job.jobs_id" :value="job.jobs_id"
        >{{ job.name }} - {{ job.code_job }}</option
      >
    </select>
    <select class="form-select" v-model="interest">
      <option value="all">Interesse - Todos</option>
      <option value="0">Interessa</option>
      <option value="1">Stand-By</option>
      <option value="2">Não Interessa</option>
    </select>
    <table class="table" id="my-table">
      <thead>
        <tr>
          <th scope="col">ID Job</th>
          <th scope="col">Nome</th>
          <th scope="col">E-mail</th>
          <th scope="col">CV</th>
          <th scope="col">LinkedIn</th>
          <th scope="col">Competências</th>
          <th scope="col">+ Competências</th>
          <th scope="col">Comentários</th>
          <th scope="col">Interesse</th>
          <th scope="col">Editar</th>
          <th scope="col">Remover</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="application in filter" :key="application.id">
          <td>{{ application.code_jobs }}</td>
          <td>{{ application.candidate_name }}</td>
          <td>
            <a :href="`mailto:${application.candidate_email}`">{{
              application.candidate_email
            }}</a>
          </td>
          <td>
            <span v-if="itemsContains(application.curriculum)">
              <a target="blank" id="cv" @click="CV(application.id_application)"
                ><img style="width:20px" src="../assets/pdf.svg" alt=""
              /></a>
            </span>
            <span v-else>
              <a target="blank" id="cv" @click="CV(application.id_application)"
                ><img style="width:20px" src="../assets/doc.svg" alt=""
              /></a>
            </span>
          </td>
          <td>
            <span v-if="application.linkedin != ''"
              ><a target="blank" :href="application.linkedin"
                ><img
                  style="width:15px"
                  src="../assets/linkedin.svg"
                  alt=""/></a
            ></span>
            <span v-else
              ><a target="blank" disabled
                ><img
                  style="width:15px"
                  src="../assets/linkedinOpacity.svg"
                  alt=""/></a
            ></span>
          </td>
          <td>
            {{ application.skills }}
          </td>
          <td>{{ application.other_skills }}</td>
          <td class="comments">
            ...
            <span>{{ application.comments }}</span>
          </td>
          <td>
            <span v-if="application.interest == 0">
              <button class="btn btn-light" id="selected">✔️</button>
              <button
                class="btn"
                id="interest"
                @click="changeInterest(application.id_application, 1)"
              >
                ⏳
              </button>
              <button
                class="btn"
                id="interest"
                @click="changeInterest(application.id_application, 2)"
              >
                ❌
              </button>
            </span>
            <span v-if="application.interest == 1">
              <button
                class="btn"
                id="interest"
                @click="changeInterest(application.id_application, 0)"
              >
                ✔️
              </button>
              <button class="btn btn-light" id="selected">⏳</button>
              <button
                class="btn"
                id="interest"
                @click="changeInterest(application.id_application, 2)"
              >
                ❌
              </button>
            </span>
            <span v-if="application.interest == 2">
              <button
                class="btn"
                id="interest"
                @click="changeInterest(application.id_application, 0)"
              >
                ✔️
              </button>
              <button
                class="btn"
                id="interest"
                @click="changeInterest(application.id_application, 1)"
              >
                ⏳
              </button>
              <button class="btn btn-light" id="selected">❌</button>
            </span>
          </td>
          <td>
            <button
              id="edit"
              data-toggle="modal"
              data-target="1"
              @click="openModal(application.id_application)"
            >
              🖊️
            </button>
          </td>
          <td>
            <button id="trash" @click="deleteApp(application.id_application)">
              🗑️
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <p>✔️-Enquadra | ⏳-StandBy | ❌-Não Enquadra</p>
    <span v-if="this.total > 1">
      <span v-if="this.currentPage == 1">
        <button
          @click="prevPage()"
          type="button"
          class="btn btn-primary"
          disabled
        >
          Prev
        </button></span
      >
      <span v-else>
        <button @click="prevPage()" type="button" class="btn btn-primary">
          Prev
        </button>
      </span>
      {{ currentPage }}/{{ total }}
      <span v-if="this.currentPage == this.total"
        ><button
          @click="nextPage()"
          type="button"
          class="btn btn-primary"
          disabled
        >
          Next
        </button></span
      >
      <span v-else>
        <button @click="nextPage()" type="button" class="btn btn-primary">
          Next
        </button></span
      >
    </span>
    <dialog id="editCandidate">
      <form method="dialog">
        <h1>Editar Candidato</h1>
        <span v-for="info in candidate" :key="info.id_application">
          <div class="form-group">
            <label for="name">Nome:</label>
            <input
              type="text"
              class="form-control"
              id="name"
              aria-describedby="emailHelp"
              :placeholder="info.candidate_name"
              readonly
            />
          </div>
          <div class="form-group">
            <label for="phone">Telefone:</label>
            <input
              type="text"
              class="form-control"
              id="phone"
              aria-describedby="emailHelp"
              :placeholder="info.cellphone"
              readonly
            />
          </div>
          <label for="email">Email:</label>
          <div class="form-group">
            <input
              type="email"
              class="form-control"
              id="email"
              :placeholder="info.candidate_email"
              readonly
            />
          </div>
          <div class="form-group">
            <label>Competências:</label><br />
            <span v-for="sel in selected1" :key="sel.value"
              ><b>{{ sel.text }} | </b>
            </span>
            <multiselect
              v-model="selected"
              deselect-label="Can't remove this value"
              track-by="text"
              label="text"
              placeholder="Select one"
              :options="options"
              :multiple="true"
            >
            </multiselect>
          </div>
          <div class="form-group">
            <span v-if="info.other_skills == ''">
              <input
                type="text"
                class="form-control"
                id="skills"
                placeholder="Outras competências"
                readonly
              />
            </span>
            <span v-else
              ><input
                type="text"
                class="form-control"
                id="skills"
                :placeholder="info.other_skills"
                readonly
            /></span>
          </div>
          <div class="form-group">
            <label for="message">Mensagem:</label>
            <textarea
              class="form-control"
              id="message"
              rows="3"
              :placeholder="info.about"
              readonly
            ></textarea>
          </div>
          <div class="form-group">
            <label for="comment">Comentários:</label>
            <textarea
              class="form-control"
              id="comment"
              rows="3"
              v-model="comment"
            >
            </textarea>
          </div>
          <button
            @click="comments(info.id_application)"
            style="border:none; background-color: #555555; color:white"
            type="submit"
          >
            Gravar
          </button>
          <button
            style="border:none; background-color: white; text-align:center"
            @click="closeModal()"
          >
            Fechar
          </button>
        </span>
      </form>
    </dialog>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import { mapGetters } from "vuex";
import Loading from "../components/Loading.vue";
export default {
  components: { Multiselect, Loading },
  data: function() {
    return {
      applications: [],
      search: "",
      jobs: [],
      skills: [],
      idJob: "all",
      interest: "all",
      candidate: [],
      selected: [],
      options: [],
      comment: "",
      type: "",
      currentPage: 1,
      pageSize: 10,
      total: "",
      options1: [],
      selected1: [],
      values: [],
      load: false,
    };
  },
  created() {
    this.getAllApplications();
    this.getSkill();
    this.allSkills();
  },
  methods: {
    //GET APPLICATIONS
    async getAllApplications() {
      this.applications = [];
      try {
        await this.$store.dispatch("fetchApplications");
        this.applications = this.getApplications.data;
      } catch (err) {
        this.$swal({
          title: err,
          icon: "error",
          confirmButtonText: "Ok!",
        });
      } finally {
        this.getAllJobs();
      }
    },
    async getSkill() {
      try {
        await this.$store.dispatch("fetchApplicationsSkills");
        this.skills = this.getAppSkills.data;
        let array = [];
        for (let i = 0; i < this.applications.length; i++) {
          for (let j = 0; j < this.skills.length; j++) {
            if (
              this.applications[i].id_application ==
              this.skills[j].application_id
            ) {
              array.push(this.skills[j].name);
            }
            this.applications[i].skills = array;
          }
          array = [];
        }
      } catch (err) {
        this.$swal({
          title: err,
          icon: "error",
          confirmButtonText: "Ok!",
        });
      }
    },
    async getAllJobs() {
      try {
        await this.$store.dispatch("fetchJobs");
        this.jobs = this.getJobs.data;
        for (let i = 0; i < this.applications.length; i++) {
          for (let j = 0; j < this.jobs.length; j++) {
            if (this.jobs[j].jobs_id == this.applications[i].id_jobs) {
              this.applications[i].code_jobs = this.jobs[j].code_job;
            } else if (this.applications[i].id_jobs == 0) {
              this.applications[i].code_jobs = "ESP";
            }
          }
        }
      } catch (err) {
        this.$swal({
          title: err.data.status,
          icon: "error",
          confirmButtonText: "Ok!",
        });
      }
    },
    async CV(id) {
      try {
        await this.$store.dispatch("getCurriculum", {
          id: id,
        });
      } catch (err) {
        this.$swal({
          title: err.data.status,
          icon: "error",
          confirmButtonText: "Ok!",
        });
      }
    },
    async comments(id) {
      this.$swal({
        title: "Tem a certeza que pretende guardar os dados?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim, Guardar",
      }).then((result) => {
        if (result.isConfirmed) {
          this.values = [];
          for (let i = 0; i < this.selected.length; i++) {
            this.values.push(this.selected[i].value);
          }
          try {
            this.$store.dispatch("putComment", {
              id: id,
              comments: this.comment,
            });
            this.addSkill(id);
            this.$swal({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 1500,
              icon: "success",
              title: "Dados atualizados",
            });
          } catch (err) {
            this.$swal({
              title: err.data.status,
              icon: "error",
              confirmButtonText: "Ok!",
            });
          }
        } else {
          this.openModal(id);
        }
        this.getAllApplications();
        this.getSkill();
      });
    },
    async allSkills() {
      try {
        await this.$store.dispatch("fetchSkills");
        for (let i = 0; i < this.getSkills.data.length; i++) {
          this.options.push({
            value: this.getSkills.data[i].id_skills,
            text: this.getSkills.data[i].name,
          });
        }
      } catch (err) {
        this.$swal({
          title: err,
          icon: "error",
          confirmButtonText: "Ok!",
        });
      }
    },
    async addSkill(id) {
      let id_skills = [];
      for (let i = 0; i < this.selected.length; i++) {
        id_skills.push(this.selected[i].value);
      }
      try {
        await this.$store.dispatch("addSkillToCandidate", {
          id: id,
          skills: id_skills,
        });
      } catch (err) {
        this.$swal({
          title: err,
          icon: "error",
          confirmButtonText: "Ok!",
        });
      }
    },
    async deleteApp(id) {
      this.candidate = this.applications.filter(
        (application) => application.id_application == id
      );
      this.$swal({
        title: `Tem a certeza que pretende eliminar os dados do(a) ${this.candidate[0].candidate_name}?`,
        text: `Ao eliminar este candidato perderá todos os dados do mesmo!`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim, Eliminar",
      }).then((result) => {
        if (result.isConfirmed) {
          this.load = true
          try {
            this.$store.dispatch("deleteApplication", {
              id: id,
            });
            this.$swal({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 1500,
              icon: "success",
              title: "Candidato eliminado",
            });
          } catch (err) {
            this.$swal({
              title: err.data.status,
              icon: "error",
              confirmButtonText: "Ok!",
            });
          }finally{
            this.load = false
          }
          this.getAllApplications();
          this.getSkill();
        }
      });
    },
    async changeInterest(id, type) {
      try {
        this.$store.dispatch("putInterest", {
          id: id,
          interest: type,
        });
        this.$swal({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 1500,
          icon: "success",
          title: "Interesse alterado",
        });
      } catch (err) {
        this.$swal({
          title: err.data.status,
          icon: "error",
          confirmButtonText: "Ok!",
        });
      }
      this.getAllApplications();
      this.getSkill();
    },
    async nextPage() {
      if (this.currentPage * this.pageSize < this.filterCandidates.length)
        this.currentPage++;
    },
    async prevPage() {
      if (this.currentPage > 1) this.currentPage--;
    },
    closeModal() {
      document.getElementById("editCandidate").close();
    },
    itemsContains(file) {
      return file.includes(".pdf");
    },
    openModal(id) {
      this.candidate = [];
      this.selected1 = [];
      this.selected = [];
      document.getElementById("editCandidate").showModal();
      this.candidate = this.applications.filter(
        (application) => application.id_application == id
      );
      this.comment = this.candidate[0].comments;
      for (let i = 0; i < this.candidate[0].skills.length; i++) {
        for (let j = 0; j < this.options.length; j++) {
          if (this.candidate[0].skills[i] == this.options[j].text) {
            this.selected1.push({
              value: this.options[j].value,
              text: this.candidate[0].skills[i],
            });
          }
        }
      }
    },
  },
  computed: {
    ...mapGetters(["getApplications"]),
    ...mapGetters(["getJobs"]),
    ...mapGetters(["getAppSkills"]),
    ...mapGetters(["getCurriculum"]),
    ...mapGetters(["getSkills"]),
    filterCandidates() {
      return this.applications.filter((application) => {
        let filterResult = true;
        let filterJobs = true;
        let filterInterest = true;
        if (
          this.search == "" &&
          this.idJob == "all" &&
          this.interest == "all"
        ) {
          return filterResult && filterJobs && filterInterest;
        }
        if (this.search !== "") {
          this.currentPage = 1;
          if (
            application.candidate_name
              .toLowerCase()
              .includes(this.search.toLowerCase())
          ) {
            filterResult = application.candidate_name
              .toLowerCase()
              .includes(this.search.toLowerCase());
            return filterResult;
          }
          //email
          if (
            application.candidate_email
              .toLowerCase()
              .includes(this.search.toLowerCase())
          ) {
            filterResult = application.candidate_email
              .toLowerCase()
              .includes(this.search.toLowerCase());
            return filterResult;
          }
          for (let i = 0; i < application.skills.length; i++) {
            if (
              application.skills[i]
                .toLowerCase()
                .includes(this.search.toLowerCase())
            ) {
              filterResult = application.skills[i]
                .toLowerCase()
                .includes(this.search.toLowerCase());
              return filterResult;
            }
          }
        }
        //INTEREST
        if (this.interest !== "all") {
          filterInterest = application.interest == this.interest;
          this.currentPage = 1;
          return filterInterest;
        }
        //IDJOBS
        if (this.idJob !== "all") {
          filterJobs = application.id_jobs == this.idJob;
          this.currentPage = 1;
          return filterJobs;
        }
      });
    },
    filter() {
      return this.filterCandidates
        .slice()
        .reverse()
        .filter((row, index) => {
          this.total = Math.ceil((index + 1) / this.pageSize);
          let start = (this.currentPage - 1) * this.pageSize;
          let end = this.currentPage * this.pageSize;
          if (index >= start && index < end) return true;
        });
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
#list {
  padding: 50px 50px 0px 250px;
}
h1 {
  margin-bottom: 50px;
}
dialog {
  width: 600px;
  border: 1px solid grey;
  border-radius: 5px;
}
.comments {
  position: relative;
}
.comments span {
  position: absolute;
  top: 0;
  transform: translateY(10%);
  display: none;
  background: white;
  z-index: 20;
  min-width: 150%;
  padding: 1rem;
  border: 1px solid silver;
  border-radius: 5px;
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.08), 0 0 6px rgba(0, 0, 0, 0.05);
}
.comments:hover span {
  display: inline;
}

input {
  margin-bottom: 20px;
  margin-right: 10px;
  border-radius: 5px;
  border: 1px solid silver;
}
select {
  margin-right: 10px;
  border-radius: 5px;
  height: 27px;
  border: 1px solid silver;
}
tbody {
  font-size: 11px;
}
thead {
  font-size: 12px;
}
form {
  text-align: left;
}
dialog h1 {
  text-align: center;
  margin-bottom: 10px;
}
dialog button {
  border-radius: 5px;
  text-align: center;
}
#edit,
#trash,
#send {
  background: none;
  border: none;
}
#cv {
  cursor: pointer;
}
#selected {
  border-color: green;
  font-size: 13px;
}
#interest {
  font-size: 13px;
}

td {
  vertical-align: middle;
}
label {
  font-size: 18px;
}
</style>
